import { render, staticRenderFns } from "./NoDataSad.vue?vue&type=template&id=62b9c078&"
import script from "./NoDataSad.vue?vue&type=script&lang=js&"
export * from "./NoDataSad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports